<template>
  <div style="margin: 2%">
    <b-row>
      <b-col>
        <h2 class="text-primary" style="margin-bottom: 0px">
          <i class="fas fa-barcode mr-2" /> Etiquetas
        </h2>
      </b-col>
      <b-btn :disabled="selectedProducts.length < 1" @click="printTags()">
        <i class="fas fa-print mr-1" /> Imprimir
      </b-btn>
    </b-row>
    <br />
    <b-row>
      <b-col>
        <CollapseOfTheProductFilter v-model="searchParams" @filter="select()" />
      </b-col>
    </b-row>
    <br />

    <b-row>
      <b-col>
        <h4>Produtos cadastrados</h4>

        <table-paginator :data="products" @pagechange="select($event)">
          <b-table small :items="products.data" :fields="fields">
            <template #cell(action)="data">
              <b-btn @click="addProduct(data.item)" size="sm" variant="link">
                <i class="fas fa-plus" />
              </b-btn>
              <b-btn @click="removeProduct(data.item)" size="sm" variant="link"
                ><i class="fas fa-minus" />
              </b-btn>
            </template>
          </b-table>
        </table-paginator>
      </b-col>
      <b-col>
        <h4>Produtos selecionados</h4>
        <small class="text-info d-md-block d-none"
          >{{ selectedProducts.length }} produto{{ this.plural }} selecionado{{
            this.plural
          }}!
        </small>
        <b-table small :items="selectedProducts" :fields="productsSelected">
        </b-table>
      </b-col>
    </b-row>
  </div>
</template>
<script>
import CollapseOfTheProductFilter from "@/components/product/filter/CollapseOfTheProductFilter";
import TablePaginator from "@/components/sections/TablePaginator.vue";

export default {
  components: { CollapseOfTheProductFilter, TablePaginator },

  data() {
    return {
      searchParams: {},
      fields: [
        {
          key: "base_sku_id",
          label: "Cod.",
          sortable: true,
          class: "text-center",
        },
        {
          key: "description",
          label: "Descrição",
          sortable: true,
          class: "text-center",
        },
        {
          key: "action",
          label: "",
          sortable: false,
          class: "text-center",
        },
      ],

      productsSelected: [
        {
          key: "base_sku_id",
          label: "Cod.",
          class: "text-center",
        },
        {
          key: "description",
          label: "Descrição",
          class: "text-center",
          style: "font-size: 15%",
        },
        {
          key: "quantity",
          label: "Nº Etiquetas",
          class: "text-center",
        },
        {
          key: "action",
          label: "",
          class: "text-center",
        },
      ],
    };
  },

  mounted() {
    this.select();

    this.$store.commit("pageHasLoaded");
  },
  computed: {
    products() {
      return this.$store.state.products.products.products;
    },
    selectedProducts() {
      return this.$store.state.productsPrintTag.selectedProducts;
    },
    plural() {
      if (this.selectedProducts.length > 1) {
        return "s";
      }

      return "";
    },
  },

  methods: {
    select(page = 1) {
      this.searchParams.page = page;

      this.$store.commit("showLoading");
      this.$store
        .dispatch("products/getProducts", this.searchParams)
        .then((response) => {
          this.$store.commit("hideLoading");
        })
        .catch((error) => {
          this.$store.commit("hideLoading");
        });
    },

    addProduct(product) {
      this.$store.commit("productsPrintTag/increaseProduct", {
        product: product,
        quantity: 1,
      });
    },
    removeProduct(product) {
      this.$store.commit("productsPrintTag/decreaseProduct", product);
    },
    printTags() {
      window.open("etiquetas/imprimir");
    },
  },
};
</script>

<style>
</style>